// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__cpoUp","Header":"Table_Header__2gwPb","TableCount":"Table_TableCount__24fLZ","Content":"Table_Content__260tL","TableHeader":"Table_TableHeader__3SVLE"};